import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation.js';
import Footer from '../components/Footer.jsx';
import { brandText } from '../components/BrandText.jsx';
import { localizePath } from '../utils/localizedRoutes.js';
import { teamAssets } from '../assets/team/index.js';
import teamProfiles from '../profile/index.cjs';

const { teamMembers } = teamProfiles;

const TeamPage = () => {
  const { currentLang, getPageTranslations } = useTranslation('team');
  const t = getPageTranslations('team');

  return (
    <div className="min-h-screen bg-bg-main text-text-primary">
      <main className="site-main">
        <section className="site-hero site-hero--single">
          <div className="site-hero__copy">
            <h1 className="site-title">{t.hero?.title}</h1>
            <p className="site-lead">{brandText(t.hero?.intro)}</p>
            <p className="site-copy team-members-intro">{t.hero?.members}</p>
          </div>
        </section>

        <section className="signal-section">
          <div className="team-grid">
            {teamMembers.map((member) => {
              const profile = member.profiles[currentLang] || member.profiles.en;

              return (
                <Link
                  key={member.slug}
                  to={localizePath(`/team/${member.slug}`, currentLang)}
                  className="team-card homepage-card"
                >
                  <div className="team-card__photo">
                    <img src={teamAssets[member.slug]?.photo} alt={profile.hero.imageAlt} />
                  </div>
                  <div className="team-card__body">
                    {profile.hero.kicker && <p className="profile-role">{brandText(profile.hero.kicker)}</p>}
                    <h2>{member.displayName}</h2>
                    <p className="team-card__headline">{profile.hero.subtitle}</p>
                    <p className="team-card__summary">{profile.summary}</p>
                    <span className="site-text-link team-card__cta">{t.card?.cta}</span>
                  </div>
                </Link>
              );
            })}
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default TeamPage;
